export const environment = {
  production: false,
  raisedBugPhase: "dev",
  maintenanceMode: false,
  maintenanceHours: 2,
  apiUrl: "https://dev.api.catexpert.ab-inbev.com/",
  baseUrl: "https://dev.api.catexpert.ab-inbev.com/dev-pho/api/project/",
  expurl: "https://dev.api.catexpert.ab-inbev.com/pho-go-process/",
  phoBaseUrl: "https://dev.api.catexpert.ab-inbev.com/dev-pho/api/v1",
  phoBaseUrlV2: "https://dev.api.catexpert.ab-inbev.com/dev-pho/api/v2",
  phoBaseUrlV3: "https://dev.api.catexpert.ab-inbev.com/dev-pho/api/v3",
  goProcess: `https://dev.api.catexpert.ab-inbev.com/pho-go-process/tasks/`,
  goProcessStates: `https://dev.api.catexpert.ab-inbev.com/pho-go-process/refs/`,
  phoTaskStreamUrl: `https://dev.api.catexpert.ab-inbev.com/dev-pho/api/tasks/`,
  chatbotApiUrl: "https://api.insights-copilot.dev.ab-inbev.com/v2",
  chatbotProjectKey: "marketing_aipho_ghq",
};
